module.exports = __webpack_public_path__ + "img/Nika Amashukeli.9bb6770e.png";